import React, { useRef, useState } from 'react';
import Gallery from './Gallery';
import BreadOrderForm from './BreadOrderForm';
import RecipeModal from './RecipeModal';
import { galleryData } from '../data/galleryData';
import './EnhancedComponents.css';

const Pane = () => {
  const galleryRef = useRef();
  const [isOrderFormOpen, setIsOrderFormOpen] = useState(false);
  const [isRecipeModalOpen, setIsRecipeModalOpen] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const handleOrderBread = () => {
    setIsOrderFormOpen(true);
  };

  const handleViewRecipes = () => {
    setIsRecipeModalOpen(true);
  };

  const handleViewBakery = () => {
    galleryRef.current?.openGallery(0);
  };

  const closeOrderForm = () => {
    setIsOrderFormOpen(false);
  };

  const closeRecipeModal = () => {
    setIsRecipeModalOpen(false);
  };

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <section id="pane" className="section pane-section">
      <div className="section-header">
        <img src="/images/pane.png" alt="Pane" className="section-icon" />
        <h1>Pane</h1>
      </div>
      <p>
        The foundation of many meals around the world - <b>Bread!</b> From crusty baguettes to soft sandwich loaves, from traditional sourdough to artisanal focaccia, bread has been nourishing humanity for thousands of years.
		Each culture has its own unique take on this essential staple food.
      </p>

	     {showMore && (
          <div className="extended-intro">
            <p>Did you know that bread is the main ingredient in the most famous Italian meal there is! Pizza is amazing and in order to make pizza, you need dough, just like bread.</p>
          </div>
        )}

      <div className="cta-buttons">
        <button className="cta-btn primary" onClick={handleCelebration}>
          <i className="fas fa-pizza-slice"></i>
          {showMore ? 'Less' : 'More About Food'}
        </button>

        <button className="cta-btn secondary" onClick={handleOrderBread}>
          <i className="fas fa-shopping-cart"></i>
          Order Fresh Bread
        </button>

        <button className="cta-btn secondary" onClick={handleViewRecipes}>
          <i className="fas fa-book-open"></i>
          Family Recipes
        </button>

		<button className="cta-btn secondary" onClick={handleViewBakery}>
          <i className="fas fa-utensils"></i>
          Mangia!
        </button>
      </div>
      
      <Gallery ref={galleryRef} images={galleryData.pane} sectionName="What's to eat?  Breakfast, Snacks, Lunch, Appetizers, Dinner, & Dessert." thumbnailSize={300} maxDisplay={4} />
      
      <BreadOrderForm 
        isOpen={isOrderFormOpen} 
        onClose={closeOrderForm} 
      />

      <RecipeModal 
        isOpen={isRecipeModalOpen} 
        onClose={closeRecipeModal} 
      />
    </section>
  );
};

export default Pane;
